import React, { useCallback, useEffect, useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import BlogHeader from '../../Organisms/BlogHeader';

import { IArticleProps } from './Article.definitions';

/** CSS import */
import Styles from './Article.module.scss';
import MainSection from './Components/Organisms/MainSection';
import BottomSection from './Components/Organisms/BottomSection';
import { useFetchArticle } from 'Pages/Blog/Hooks/useFetchArticle';
import { useParams } from 'react-router';
import BlogFooter from '../../Organisms/BlogFooter';
import { Helmet } from 'react-helmet';
import { IArticleMeta } from 'Pages/Blog/Hooks/Definitions/Article.d';

const Article: React.FC<IArticleProps> = ({}: IArticleProps) => {
  const params = useParams<{ slug: string }>();
  const slug = params.slug || '';
  const { data, isFetching, response } = useFetchArticle({
    slug,
  });

  const isReady = useMemo(() => {
    return !isFetching && !!response;
  }, [isFetching, response]);

  const renderHelmet = () => {
    if (data.meta && data.meta.length) {
      return (
        <Helmet>
          {data.meta.map((meta, index) =>
            meta.name === 'title' ? (
              <title key={`${index}-${meta.id}-${meta.name}`}>
                {meta.content}
              </title>
            ) : (
              <meta
                key={`${index}-${meta.id}-${meta.name}`}
                name={meta.name}
                content={meta.content}
              />
            ),
          )}
        </Helmet>
      );
    }
    return <div />;
  };

  return (
    <div className={Styles['wrapper']}>
      {renderHelmet()}
      <BlogHeader />
      <div className={Styles['article-body']}>
        <MainSection
          articleData={data}
          isReady={isReady}
          isFetching={isFetching}
        />
        <BottomSection
          articleData={data}
          isReady={isReady}
          isFetching={isFetching}
        />
        <BlogFooter />
      </div>
    </div>
  );
};

export default Article;
